import axios from 'axios';

const API_BASE = '/api/quote-requests';

export const quoteRequestService = {
  getAll: async (params = {}) => {
    const response = await axios.get(API_BASE, { params });
    return response.data;
  },
  getById: async (id) => {
    const response = await axios.get(`${API_BASE}/${id}`);
    return response.data;
  },
  create: async (data) => {
    const response = await axios.post(API_BASE, data);
    return response.data;
  },
  update: async (id, data) => {
    const response = await axios.put(`${API_BASE}/${id}`, data);
    return response.data;
  },
  submit: async (id) => {
    const response = await axios.post(`${API_BASE}/${id}/submit`);
    return response.data;
  },
  withdraw: async (id) => {
    const response = await axios.post(`${API_BASE}/${id}/withdraw`);
    return response.data;
  },
  approve: async (id, data = {}) => {
    const response = await axios.post(`${API_BASE}/${id}/approve`, data);
    return response.data;
  },
  reject: async (id, data = {}) => {
    const response = await axios.post(`${API_BASE}/${id}/reject`, data);
    return response.data;
  },
};
